import styles from '@styles/scss/common/_promoVideo.module.scss';
import { parseCookies, setCookie } from 'nookies';
import { useEffect, useState } from 'react';

import SvgX from '@components/partials/svg/svgBlackxX';

export default function PromoVideo(): JSX.Element {
    const [videoToggle, setVideoToggle] = useState(false);
    const [bannerVideoUrl, setBannerVideoUrl] = useState('');
    const [destinationURL, setDestinationURL] = useState('');

    useEffect(() => {
        // Function to fetch the API endpoint
        const fetchBannerVideoUrl = async () => {
            try {
                const response = await fetch('https://api.rabbitsreviews.com/v1/snippet/banner-across');
                if (!response.ok) {
                    throw new Error('Failed to fetch banner video URL');
                }

                const data = await response.json();
                if (data && data.text && (data.text != '-' || data.text.indexOf(',') === -1)) {
                    const urls = data.text.split(',');

                    if (isStringInURLFormat(urls[0])) {
                        // Set the state with the fetched URL
                        setBannerVideoUrl(urls[0]);
                        setDestinationURL(urls[1]);
                    }
                }

                // Set the state with the fetched URL
            } catch (error) {
                setBannerVideoUrl('');
            }
        };
        const cookies = parseCookies();
        //If no cookies are found, the promo banner wasn't closed
        if (!cookies.videomodal_status) {
            setVideoToggle(true);
            fetchBannerVideoUrl();
        }
    }, []); // Empty dependency array ensures that this effect runs only once when the component mounts

    const isStringInURLFormat = (str: string) => {
        // Regular expression pattern for a basic URL structure
        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;

        // Test if the string matches the regular expression
        return urlPattern.test(str);
    };
    const closeAd = (eventLabel: string) => {
        if (typeof window !== 'undefined' && (window as any).dataLayer) {
              const eventData = {
                  event: eventLabel,
                  event_category: 'User Action',
                  event_action: eventLabel,
                  event_label: eventLabel
              };

              (window as any).dataLayer.push(eventData);
          }
        // Set the "promo" cookie to expire in 2 days
        setCookie(null, 'videomodal_status', 'true', {
            maxAge: 172800,
            path: '/'
        });
        setVideoToggle(false);
    };

    return videoToggle && bannerVideoUrl ? (
        <div className={styles.promoVideo}>
            <div className={styles.promoVideoContainer}>
                <div className={styles.closeIcon}>
                    <button
                        className={styles.closeButton}
                        onClick={() => closeAd('video-banner-closed')}
                        data-event-category="User Action"
                        data-event-action="video-banner-closed"
                        data-event-label="video-banner-closed">
                        <SvgX color={'white'} />
                    </button>
                </div>
                <a
                    href={destinationURL}
                    data-event-category="User Action"
                    data-event-action="video-banner-click"
                    data-event-label="video-banner-click"
                    target="_blank"
                    onClick={() => closeAd('video-banner-click')}>
                    <div className={styles.promoContainer}>
                        <video muted autoPlay loop playsInline className={styles.video}>
                            <source src={bannerVideoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </a>
            </div>
        </div>
    ) : (
        <></>
    );
}